import gql from 'graphql-tag';

export default gql`
    query GetAllocateLoadBoxes($jobId: Int, $proppantId: Int) {
      getAllocateLoadBoxes(jobId: $jobId, proppantId: $proppantId) {
        boxId
        boxDesc
        semiAllocated
        proppantId
        proppantColor
        currentProppantWeight
      }
    }
`;